module.exports = __webpack_public_path__ + "img/games-24.7a4209b8.jpg";